module.exports = __webpack_public_path__ + "168d3652c85397f86f179dc7686d0122.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/dummy_image_sheep.png
// module id = 89
// module chunks = 0